import { useEffect, useState } from "react";
import axios from "axios";
import { CheckCircle2, Clock, XCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Caparra() {
  const [stato, setStato] = useState(null);
  const params = new URLSearchParams(window.location.search);
  const sid = params.get("session_id");
  const annullato = params.get("annullato");

  useEffect(() => {
    if (!sid) return;
    let tentativi = 0;
    const chiedi = async () => {
      try {
        const r = await axios.get(`${API}/public/deposit/${sid}`);
        setStato(r.data);
        if (r.data.payment_status !== "paid" && tentativi < 10) {
          tentativi += 1;
          setTimeout(chiedi, 2000);
        }
      } catch {
        setStato({ payment_status: "errore" });
      }
    };
    chiedi();
  }, [sid]);

  const pagato = stato?.payment_status === "paid";

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0b0f19] p-6" data-testid="caparra-page">
      <div className="w-full max-w-md rounded-2xl border border-slate-800 bg-[#111827] p-8 text-center text-slate-100">
        {annullato ? (
          <>
            <XCircle className="mx-auto h-12 w-12 text-slate-500" />
            <h1 className="mt-4 text-2xl font-bold">Pagamento annullato</h1>
            <p className="mt-2 text-sm text-slate-400">
              Il tavolo resta in attesa: se vuoi confermarlo, riapri il link che ti è stato mandato.
            </p>
          </>
        ) : pagato ? (
          <>
            <CheckCircle2 className="mx-auto h-12 w-12 text-emerald-400" />
            <h1 className="mt-4 text-2xl font-bold">Tavolo confermato</h1>
            <p className="mt-2 text-sm text-slate-400">
              Abbiamo ricevuto la cauzione di{" "}
              <strong className="text-slate-100">{Number(stato.amount).toFixed(2)}€</strong>
              {stato.venue ? ` per ${stato.venue}` : ""}. Te la restituiamo quando arrivate: ci vediamo presto.
            </p>
          </>
        ) : (
          <>
            <Clock className="mx-auto h-12 w-12 animate-pulse text-amber-400" />
            <h1 className="mt-4 text-2xl font-bold">Stiamo confermando il pagamento</h1>
            <p className="mt-2 text-sm text-slate-400">
              Un attimo solo, non chiudere la pagina.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
